import type { TradableAssetsContent } from "../types";

export const tradableAssets: TradableAssetsContent = {
  meta: {
    title: "Tradable Assets | 300+ Instruments | Flex Fund",
    description:
      "Trade 300+ instruments — forex, indices, metals, crypto, energies, US equities — on one Flex Fund MetaTrader 5 prop firm account.",
  },
  hero: {
    line1: "Forex. Indices.",
    line2: "Metals. Crypto.",
    highlight: "One account.",
    lede: "Every instrument our liquidity providers offer. The same spreads on evaluation and on funded.",
  },
  counts: {
    forexPairs: "Forex pairs",
    commodities: "Commodities",
    crypto: "Crypto",
    indicesStock: "Indices & Stock",
  },
  chips: {
    ALL: "All",
    FOREX: "Forex",
    COMMODITIES: "Commodities",
    CRYPTO: "Crypto",
    INDICES_STOCK: "Indices & Stock",
  },
  table: { symbol: "Symbol", category: "Category" },
  emptyState: "No instruments match the current filter.",
  footnote: "Same raw spreads in evaluation as in funded.",
  categories: {
    FOREX: "FOREX",
    INDICES: "INDICES",
    METALS: "METALS",
    CRYPTO: "CRYPTO",
    ENERGIES: "ENERGIES",
    STOCKS: "STOCKS",
  },
};
